export class Constants {
    public static MAIN_ENV_URL = '';
    // public static MAIN_ADMIN_ENV_URL = '';

    // API
    public static URL_DASH = '/';
    public static DOCTOR_API = 'doctor/';
    public static DOCTORS_API = '/doctors';
    public static CLINIC_API = '/clinic/';
    public static CLINICS_API = '/clinics';
    public static INVOICE_API = 'invoice/';
    public static PAYMENT_API = '/payment';
    public static CUSTOMER_API = 'customer/';
    public static SLASH_INVOICES = '/invoices';
    public static SLASH_INVOICE = '/invoice';
    public static SLASH_CHECKUP_SLASH = '/checkup/';
    public static SLASH_PRESCRIPTIONS = '/prescriptions';
    public static SLASH_REMIND_PAYMENT = '/remindPayment';
    public static PET_API = '/pet/';
    public static INTERNAL_LOGIN_API = 'login';
    public static DOCTOR_LOGIN_API = 'doctor/login';
    public static DOCTOR_ACTIVATE_API = 'doctor/activate/';
    public static DOCTOR_REGISTER_API = 'doctor/register';
    public static DOCTOR_CUSTOMER_API = 'doctor/customer/';
    public static DOCTOR_CHANGE_PASSWORD_API = 'doctor/changePassword';
    public static CHANGE_PASSWORD_API = 'changePassword';
    public static DOCTOR_FORGOT_PASSWORD_API = 'doctor/forgotPassword';
    public static FORGOT_PASSWORD_API = 'forgotPassword';
    public static DOCTOR_REGISTER_CUSTOMER_API = 'doctor/registerCustomer';
    public static DOCTOR_CHECKUP_API = 'doctor/checkup/';
    public static DOCTOR_CHECKUP_INTIALIZE_API = 'doctor/checkup/initialize';
    public static DOCTOR_VACCINATION_API = '/vaccination/';
    public static LAB_REPORTS_API = '/lab/';
    public static DOCTOR_LOGOUT_API = 'doctor/logout';
    public static LOGOUT_API = 'logout';
    public static MEDICAL_HISTORY_LIST_API = '/medicalHistory/';
    public static MEDICINE_RECORDS_API = '/medicine/';
    public static DRUG_LIST_API = 'drug/';
    public static DRUG_LIST_API_DASH = '/drug/';
    public static OTHERSERVICES_LIST_API = '/otherServices/';
    public static SURGERY_RECORDS_API = '/surgery/';
    public static DOCTOR_UPLOAD_PROFILE_IMAGE_API = 'doctor/uploadProfileImage/';
    public static DOCTOR_UPLOAD_DIGITAL_SIGNATURE_API = 'doctor/uploadDigitalSignatureImage/';
    public static DOCTOR_OTP_GENERATE_API = 'doctor/otp/generateOtp';
    public static DOCTOR_OTP_VERIFY_API = 'doctor/otp/verifyOtp';
    public static DOCTOR_UPLOAD_VACCINATION_API = 'doctor/uploadVaccinationReport/';
    public static DOCTOR_UPLOAD_LAB_REPORT_API = 'doctor/uploadLabReport/';
    public static DOCTOR_UPLOAD_SURGERY_REPORT_API = 'doctor/uploadSurgeyReport/';
    public static DOCTOR_UPLOAD_VACCINATION_REPORT_API = 'doctor/uploadVaccinationReport/';
    public static DOCTOR_UPLOAD_MEDICAL_HISTORY_API = 'doctor/uploadMedicalHistoryImage/';
    public static DOCTOR_BREEDS_API = 'doctor/breeds/';
    public static DOCTOR_PET_SPECIES_API = 'doctor/pet/species';
    public static DOCTOR_SETTINGS_API = '/settings';
    public static DOCTOR_FETCH_PETS_API = 'doctor/customer/pets';
    public static SLASH_DASHBOARD_API = '/dashboard';
    public static DOCTOR_LIST_API = '/listDoctor';
    public static ADD_DOCTOR_API = '/addDoctor';
    public static UPDATE_DOCTOR_API = '/updateDoctor';
    public static CREATE_DRUG_API = '/drug';
    public static DRUGS_API = '/drugs/';
    public static DRUG_API = '/drug/';
    public static DRUG_BULK_UPLOAD_API = 'drug/uploadDrugList/';
    public static NOTES_LIST_API = '/listNotes';
    public static NOTES_ADD_API = '/addNote';
    public static LINE_OF_TREATMENT_ADD_API = '/addLineOfTreatment';
    public static NOTES_API = '/note/';
    public static SUBMIT_API = '/submit';
    public static SAVE_API = '/save';
    public static LINE_OF_TREATMENT_API = '/lineOfTreatment/';
    public static CHECKUP_PENDING_API = 'checkups/PENDING';
    public static CHECKUP_COMPLETED_API = '/checkups/COMPLETED';
    public static INTERNAL_USER_API = 'internalUser/';
    public static DOCTOR_SUBSCRIPTION_API = '/doctorSubscription/';
    public static DOCTOR_SUBSCRIPTIONS_API = '/doctorSubscriptions';
    public static CLINIC_PAYMENTS_API = '/clinicPayments';
    public static CUSTOMER_PAYMENTS_API = '/customerPayments';
    public static CLINIC_PAYMENT_API = '/clinicPayment/';
    public static DOCTOR_DASHBOARD_API = '/doctorDashboard';
    public static ITERNAL_USERS_API = 'internalUsers';
    public static INACTIVE_API = '/INACTIVE';
    public static ACTIVE_API = '/ACTIVE';
    public static DOCTOR_LEAD_API = '/doctorLead/';
    public static DOCTOR_LEADS_API = '/doctorLeads';
    public static REJECTED_API = '/REJECTED';
    public static APPROVED_API = '/APPROVED';
    public static DOCTORPLANS_API = '/doctorPlans';
    public static USER_API = '/user';
    public static ROLE_API = '/role';
    public static UPLOAD_PROFILE_IMAGE_API = 'uploadProfileImage/';
    public static SLASH_BATCHES_API = '/batches';
    public static SLASH_BATCH_SLASH_API = '/batch/';
    public static SLASH_BATCH_API = '/batch';
    public static CONSUME_API = '/consume';
    public static SLASH_DRUG_SLASH_API = '/drug/';
    public static MAX_ACTIVE_DOCTOR_API = '/maxactivesubordinatecount';
    public static HARD_RESET_DOCTOR_PASSWORD = 'https://api.dev.pawsnme.com/api/v1/doctor/password-hard-reset';

    // URL
    public static HOME_URL = '/home';
    public static LOGIN_URL = '/login';
    public static DASHBOARD_URL = '/dashboard';
    public static CHANGE_PASSWORD_URL = '/profile/changepassword';
    public static MANAGE_STAFF_URL = '/profile/manageStaff';
    public static EDIT_DOCTOR_PROFILE_URL = '/profile/editProfile';
    public static PROFILE_DASHBOARD_URL = '/profile/dashboard';
    public static INVENTORY_DASHBOARD_URL = '/inventory/dashboard';
    public static REGISTER_DOCTOR_URL = '/doctor-registration';
    public static PET_DASHBOARD_URL = '/pet/dashboard';
    public static PET_REGISTRATION_URL = '/pet/registration';
    public static MOBILE_VERIFICATION_URL = '/mobile-verification';
    public static CREATE_PET_URL = '/createPet';
    public static DETAILS_URL = 'details';
    public static PET_CHECKUP_URL = '/pet/checkup';
    public static INPATIENT_PENDING_LIST_URL = '/inpatient/pendinglist';
    public static INPATIENT_COMPLETED_LIST_URL = '/inpatient/completedlist';
    public static OTP_VERIFICATION_URL = '/pet/otp-verification';
    public static BULK_UPLOAD_URL = 'https://pawsnme-dev.s3.ap-south-1.amazonaws.com/DrugTemplate/Drugs-upload-template.xlsx';
    public static DOCTOR_REGISTRATION_URL = 'https://pawsnme.com/doctor-registration/';
    public static ADMIN_HOME_PAGE_URL = '/admin/manageUser';
    public static ADMIN_LOGIN_URL = '/login';
    public static DOCTOR_SUBSCRIPTION_URL = '/doctor/subscription';
    // Constants
    public static STATUS_200 = '200';
    public static STATUS_SUCCESS = 'Success';
    public static STATUS_ACCEPT = 'ACCEPT';
    public static STATUS_REJECT = 'REJECT';
    public static STATUS_SUBMITTED = 'SUBMITTED';
    public static SUBSTRACT = 'SUBSTRACT';
    public static ADD = 'ADD';
    public static LABEL_ERROR = 'Error';
    public static LABEL_WARNING = 'Warning';
    public static LABEL_SUCCESS = 'Success';
    public static CURRENCY = 'currency';
    public static PERCENT = 'percent';
    public static UPLOAD_REPORT = 'Upload Report';
    public static ITEMS_PER_PAGE = 'itemsPerPage';
    public static PAGE_NUMBER = 'pageNumber';
    public static FROM_DATE = 'fromDate';
    public static TO_DATE = 'toDate';
    public static MOBILE_NUMBER = 'mobile_number';
    public static PET_ID = 'pet_id';
    public static LABEL_SEARCH = 'search';
    public static VACCINATION_DEWORMING_VALUE = 'VACCINATION-DEWORMING';
    public static VACCINATION_VALUE = 'VACCINATION';
    public static MEDICAL_HISTORY_VALUE = 'medicalHistory';
    public static DIAGNOSTIC_LAB_VALUE = 'LAB';
    public static DIAGNOSTIC_VALUE = 'DIAGNOSTIC';
    public static PROCEDURE_SURGERY_VALUE = 'SURGERY';
    public static SYRUP_VALUE = 'SYRUP';
    public static DROPS_VALUE = 'DROPS';
    public static POWDER_SHAMPOO_VALUE = 'POWDER-SHAMPOO';
    public static TABLET_VALUE = 'TABLET';
    public static ALL_INVENTORY_VALUE = 'ALL';
    public static CAN_FOOD_VALUE = 'CAN-FOOD';
    public static SYRUP_SUPPLEMENT_VALUE = 'SYRUP-SUPPLEMENT';
    public static OINTMENT_SPRAY_VALUE = 'OINTMENT-SPRAY';
    public static CAPSULE_VALUE = 'CAPSULE';
    public static SUPPOSITORY_VALUE = 'SUPPOSITORY';
    public static SOFTGEL_CAPSULE_VALUE = 'SOFTGEL-CAPSULE';
    public static DRY_SYRUP_VALUE = 'DRY-SYRUP';
    public static TOPICAL_POWDER_VALUE = 'TOPICAL-POWDER';
    public static ORAL_SUPPLEMENTARY_VALUE = 'ORAL-SUPPLEMENTARY';
    public static SPOT_ON_VALUE = 'SPOT-ON';
    public static OINTMENT_VALUE = 'OINTMENT';
    public static LOTION_VALUE = 'LOTION';
    public static GEL_VALUE = 'GEL';
    public static ORAL_DROPS_VALUE = 'ORAL-DROPS';
    public static EYE_DROPS_VALUE = 'EYE-DROPS';
    public static EAR_DROPS_VALUE = 'EAR-DROPS';
    public static ORAL_SPRAY_VALUE = 'ORAL-SPRAY';
    public static TOPICAL_SPRAY_VALUE = 'TOPICAL-SPRAY';
    public static CATEGORY = 'category';
    public static FOLLOWUP_VISIT_VALUE = 'FOLLOW UP VISIT';
    public static DISPOSABLE_VALUE = 'DISPOSABLE';
    public static MEDICINE_VALUE = 'MEDICINE';
    public static INJECTABLE_VALUE = 'INJECTABLE';
    public static CONSUMABLE_VALUE = 'CONSUMABLE';
    public static PRODUCT_VALUE = 'PRODUCT';
    public static SERVICES_VALUE = 'SERVICES';
    public static OTHERS_VALUE = 'OTHERS';
    public static OTHER_VALUE = 'OTHER';
    public static PATIENT_EXAMINATION = 'Patient Examination';
    public static OTHER_SERVICES_VALUE = 'otherServices';
    public static LAB_VALUE = 'LAB';
    public static SURGERY_VALUE = 'SURGERY';
    public static PAYMENT_CASH = 'CASH';
    public static PAYMENT_CARD = 'CARD';
    public static PAYMENT_UPI = 'UPI';
    public static DATE_FORMAT = 'dd-mm-yyyy';

    // Roles
    public static ROLE_ADMIN = 'Admin';
    public static ROLE_OPERATIONS = 'Operations';
    public static ROLE_DEVELOPERS = 'Developers';
    public static ROLE_ACCOUNTS = 'Accounts';
    public static ROLE_MARKETING = 'Marketing';

    public static FILE_TYPE_SUPPORTED = '.doc, .docx, .ppt, .pptx, .xls, .xlsx, .txt,.pdf,.png,.gif,.jpeg,.jpg, .rtf, .eml, .msg';
    public static EXCEL_FILE_TYPE_SUPPORTED = '.xls, .xlsx, .csv';
    public static IMAGE_FILE_TYPE_SUPPORTED = '.png,.gif,.jpeg,.jpg';

    // Error Message
    public static ERROR_INVALID_MOBILE = 'Invalid Mobile Number';
    public static ERROR_NUMBER_OFDAYS = 'Please enter number of days';
    public static ERROR_QUANTITY = 'Please enter number of items';
    public static ERROR_PRICE_MISSING_TABLET = 'Price is missing for Tablet';
    public static ERROR_PRICE_MISSING_SYRUP = 'Price is missing for Syrup';
    public static ERROR_PRICE_MISSING_VACCINATION = 'Price is missing for Vaccination / Deworming';
    public static ERROR_PRICE_MISSING_DIAGNOSTIC = 'Price is missing for Diagnostic Procedure';
    public static ERROR_PRICE_MISSING_PROCEDURE = 'Price is missing for Procedure';
    public static ERROR_PRICE_MISSING_OINTMENT = 'Price is missing for Ointment / Spray';
    public static ERROR_PRICE_MISSING_SHAMPOO = 'Price is missing for Shampoo / Powder';
    public static ERROR_PRICE_MISSING_DROPS = 'Price is missing for Drops';
    public static ERROR_PRICE_MISSING_DISPOSABLE = 'Price is missing for Disposables';
    public static ERROR_PRICE_MISSING_INJECTABLE = 'Price is missing for Injectable';
    public static ERROR_PRICE_MISSING_OTHERS = 'Price is missing for Others field';
    public static ERROR_PRICE_MISSING_LAB = 'Price is missing for Lab Report';
    public static ERROR_PRICE_MISSING_SURGERY = 'Price is missing for Surgery';
    public static ERROR_DAILY_DOSAGE_TABLET = 'Daily dosage is missing for Tablet';
    public static ERROR_DAILY_DOSAGE_SYRUP = 'Daily dosage is missing for Syrup';
    public static ERROR_CHOOSE_TABLET = 'Please choose the Tablet';
    public static ERROR_CHOOSE_SYRUP = 'Please choose the Syrup';
    public static ERROR_CHOOSE_VACCINATION = 'Please choose the Vaccination';
    public static ERROR_CHOOSE_DIAGNOSTIC = 'Please choose the Diagnostic Procedure';
    public static ERROR_CHOOSE_PROCEDURE = 'Please choose the Procedure';
    public static ERROR_CHOOSE_OINTMENT = 'Please choose Ointment / Spray';
    public static ERROR_CHOOSE_SHAMPOO = 'Please choose Shampoo / Powder';
    public static ERROR_CHOOSE_DROPS = 'Please choose Drops';
    public static ERROR_CHOOSE_DISPOSABLE = 'Please choose Disposable';
    public static ERROR_CHOOSE_INJECTABLE = 'Please choose Injectable';
    public static ERROR_CHOOSE_OTHER = 'Please choose Others';
    public static ERROR_CHOOSE_PURPOSE_VISIT = 'Please choose Purpose Of Visit';
    public static ERROR_ENTER_LAB_REMARKS = 'Please enter Lab Remarks';
    public static ERROR_ENTER_SURGERY_REMARKS = 'Please enter Surgery Remarks';
    public static ERROR_CHOOSE_VACCINATION_DATE = 'Please choose the Vaccination Date';
    public static ERROR_CHOOSE_PAYMENT_AMOUNT = 'Please choose the payment method and amount paid';
    public static ERROR_RECORD_ALREADY_ADDED = 'Record already added';
    public static ERROR_PERMISSION_NEEDED = 'You need permission to perform this action';

    // Warning Message
    public static WARNING_NO_PET_PRESENT = 'No Pet Found - Create New Pet';
    public static WARNING_IS_OUT_OF_STOCK = ' is out of stock';

    // Success Message
    public static SUCCESS_PAYMENT_DONE = 'Thanks!, payment done';
    public static SUCCESS_STAFF_ADDED = 'Staff Added Successfully';
    public static SUCCESS_STATUS_CHANGED = 'Status Changed Successfully';
    public static SUCCESS_DOCTOR_STATUS_CHANGED = 'Doctor Status Changed Successfully';
    public static SUCCESS_ITEM_DELETED = 'Item Deleted Successfully';
    public static SUCCESS_CHECKUP_UPDATED = 'Check-up details Updated';
    public static SUCCESS_ADDED = 'Added Successfully';
    public static SUCCESS_INOVICE_GENERATED = 'Invoice Generated Successfully';

    // Confirmation Message
    public static CONFIRMATION_WITHOUT_PICTURE = 'Want to Continue without taking Picture?';
    public static CONFIRMATION_DELETE_ITEM = 'Are you sure to delete the Item?';
    public static CONFIRMATION_SUBMIT_CHECKUP = 'Are you sure to Submit Checkup?';

    // dd/mm/yyyy date format to be used

}
